'use client';

import usePrevious from '@shaojiang/hooks/usePrevious';
import { useDomStore } from '@shaojiang/store/dom';
import { Direction } from '@shaojiang/types/window';

export default function useScrollDirection() {
  const scrollTop = useDomStore((state) => state.scrollTop);
  const previousScrollTop = usePrevious(scrollTop);

  return scrollTop && scrollTop > previousScrollTop ? Direction.Down : Direction.Up;
}
